<ng-container *ngIf="mostrarGridLista">
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row">
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-input [control]="formulario.get('idPedido') | formControl" [id]="'idPedido'"
                        [isReadOnly]="true" [label]="'Nro SolVen'" [mostrarImg]="false"
                        [placeholder]="'Nro SolVen'"
                        [rutaImagen]=""
                        [type]="'number'"
                        formControlName="idPedido">
        </app-lfsa-input>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-input [control]="formulario.get('descGrupoVendedor') | formControl" [id]="'descGrupoVendedor'"
                        [isReadOnly]="true" [label]="'Grupo Vendedor*'" [mostrarImg]="false"
                        [placeholder]="'Grupo Vendedor*'"
                        [rutaImagen]=""
                        [type]="'text'"
                        formControlName="descGrupoVendedor">
        </app-lfsa-input>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-12">
            <app-lfsa-input [control]="formulario.get('idCliente') | formControl" [id]="'idCliente'"
                            [isReadOnly]="true" [label]="'Cliente*'" [mostrarImg]="false"
                            [placeholder]="'Cliente'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="idCliente">
            </app-lfsa-input>
          </div>
          <label class="col-sm-3 col-form-label" for="editClientCheckbox">Cambiar Cliente</label>
          <div class="col-sm-9">
            <input (change)="editClientMethod()" [(ngModel)]="editClient" [ngModelOptions]="{standalone: true}"
                   id="editClientCheckbox" type="checkbox">
          </div>
        </div>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-12">
            <app-lfsa-input [control]="formulario.get('nombreCliente') | formControl" [id]="'nombreCliente'"
                            [isReadOnly]="true" [label]="'Nombre Cliente*'" [mostrarImg]="false"
                            [placeholder]="'Nombre Cliente'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="nombreCliente">
            </app-lfsa-input>
          </div>
          <div *ngIf="editClient" class="col-md-12 d-flex align-items-center">
            <ng-container>
              <a #btnAddCliente class="btn btn-primary" data-bs-target="#clienteModal" data-bs-toggle="modal"
                 role="button">
                <span>Seleccionar Cliente</span>
                <i class="fa fa-tags"></i>
              </a>
            </ng-container>
          </div>
        </div>


      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-combo-box [comboBox]="cmbOrganizacionVenta"
                            [control]="formulario.get('idOrgaVenta') | formControl"
                            [habilitar]="!editClient"
                            [idOpcion]="'id'"
                            [id]="'idOrgaVenta'"
                            [label]="'Organización de Venta*'"
                            [opcion]="'descripcion'"
                            formControlName="idOrgaVenta">
        </app-lfsa-combo-box>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-combo-box [comboBox]="cmbCanalVenta"
                            [control]="formulario.get('idCanalVenta') | formControl"
                            [habilitar]="!editClient"
                            [idOpcion]="'id'"
                            [id]="'idCanalVenta'"
                            [label]="'Canal de Venta*'"
                            [opcion]="'descripcion'"
                            formControlName="idCanalVenta">
        </app-lfsa-combo-box>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-combo-box [comboBox]="cmbSectorVenta"
                            [control]="formulario.get('idSectorVenta') | formControl"
                            [habilitar]="!editClient"
                            [idOpcion]="'id'"
                            [id]="'idSectorVenta'"
                            [label]="'Sector de Venta*'"
                            [opcion]="'descripcion'"
                            formControlName="idSectorVenta">
        </app-lfsa-combo-box>
      </div>
      <div *ngIf="!loading" class="form-group col-md-6">
        <app-lfsa-input [control]="formulario.get('fechaPedido') | formControl" [id]="'fechaPedido'"
                        [isReadOnly]="true" [label]="'Fecha Pedido*'" [mostrarImg]="false"
                        [placeholder]="'Fecha Pedido'"
                        [rutaImagen]=""
                        [type]="'text'"
                        formControlName="fechaPedido">
        </app-lfsa-input>
      </div>
      <ng-container *ngIf="editClient">
        <div *ngIf="!loading" class="form-group col-md-12">
          <button (click)="validateEditClientMethod()"
                  class="btn btn-success btn-block"
          >
            Validar Parametro de Cliente
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="!editClient || (editClient && validateEditClient)">
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('idDivisa') | formControl" [id]="'idDivisa'"
                          [isReadOnly]="true" [label]="'Moneda*'" [mostrarImg]="false"
                          [placeholder]="'Moneda'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="idDivisa">
          </app-lfsa-input>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('estado') | formControl" [id]="'estado'"
                          [isReadOnly]="true" [label]="'Estado'" [mostrarImg]="false"
                          [placeholder]="'Estado'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="estado">
          </app-lfsa-input>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box
            (change)="changeMotivoPedido()"
            [comboBox]="cmbAutoconsumoMotivoPedido"
            [control]="formulario.get('idMotivoPedido') | formControl"
            [idOpcion]="'id'" [id]="'idMotivoPedido'" [label]="'Motivo Pedido*'"
            [opcion]="'descripcion'"
            formControlName="idMotivoPedido">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('ctactbleDesc') | formControl" [id]="'ctactbleDesc'"
                          [isReadOnly]="true" [label]="'Cuenta Contable*'" [mostrarImg]="false"
                          [placeholder]="'Cuenta Contable'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="ctactbleDesc">
          </app-lfsa-input>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('descCondPago') | formControl" [id]="'descCondPago'"
                          [isReadOnly]="true" [label]="'Condición Pago*'" [mostrarImg]="false"
                          [placeholder]="'Condición Pago*'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="descCondPago">
          </app-lfsa-input>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
<!--          <app-lfsa-combo-box
            [comboBox]="cmbClasePedido"
            [control]="formulario.get('idClasePedido') | formControl"
            [idOpcion]="'id'" [id]="'idClasePedido'" [label]="'Clase Pedido*'"
            [opcion]="'descripcion'"
            formControlName="idClasePedido">
          </app-lfsa-combo-box>-->

          <app-lfsa-select-opt-isp
            (update)="formulario.get('idClasePedido').setValue($event)"
            [mostrarImg]="false"
            [rutaImagen]="'periodoIcon'"
            formControlName="idClasePedido"
            [control]="formulario.get('idClasePedido')"
            [claseLabel]="'letrasDefault'"
            [opcion]="'descripcion'"
            [idOpcion]="'id'"
            [comboBox]="cmbClasePedido"
            [label]="'Clase Pedido*'"
            [id]="'idClasePedido'"
            [clearContenido]=false>
          </app-lfsa-select-opt-isp>


        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box
            [comboBox]="cmbOficinaVenta"
            [control]="formulario.get('idOficinaVenta') | formControl"
            [idOpcion]="'id'" [id]="'idOficinaVenta'" [label]="'Oficina Venta*'"
            [opcion]="'descripcion'"
            formControlName="idOficinaVenta">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box
            [comboBox]="cmbCondicionExpedicion"
            [control]="formulario.get('idCond') | formControl"
            [idOpcion]="'id'" [id]="'idCond'" [label]="'Condición Expedición*'"
            [opcion]="'descripcion'"
            formControlName="idCond">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box
            (change)="changeCentro()"
            [comboBox]="cmbCentroLogistico"
            [control]="formulario.get('idCentro') | formControl"
            [idOpcion]="'id'" [id]="'idCentro'" [label]="'Centro Logistico*'"
            [opcion]="'descripcion'"
            formControlName="idCentro">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box
            [comboBox]="cmbAlmacen"
            [control]="formulario.get('idAlmacen') | formControl"
            [habilitar]="!(formulario.get('idCentro') && formulario.get('idCentro').value && formulario.get('idCentro').value.trim() !=='' )"
            [idOpcion]="'id'" [id]="'idAlmacen'" [label]="'Almacen*'"
            [opcion]="'descripcion'"
            formControlName="idAlmacen">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box
            [comboBox]="cmbGerencias"
            [control]="formulario.get('codGerencia') | formControl"
            [idOpcion]="'codGerencia'" [id]="'codGerencia'" [label]="'Gerencia*'"
            [opcion]="'descripcion'"
            formControlName="codGerencia">
          </app-lfsa-combo-box>
        </div>
      </ng-container>
      <!--    <div *ngIf="!loading" class="form-group col-md-6 mb-2 d-flex align-items-center">
            <ng-container>
              <a #btnAddCliente class="btn btn-primary" data-bs-target="#clienteModal" data-bs-toggle="modal"
                 name="addCliente" role="button">
                <span>Agregar Cliente</span>
                <i class="fa fa-tags"></i>
              </a>
            </ng-container>
          </div>
          <div *ngIf="!loading" class="form-group col-md-6 mb-2">
            <app-lfsa-input [control]="formulario.get('nombreCliente1') | formControl"
                            [id]="'nombreCliente1'" [isReadOnly]="true" [label]="'Nombre Cliente*'"
                            [mostrarImg]="false"
                            [placeholder]="'Nombre Cliente'"
                            [rutaImagen]=""
                            formControlName="nombreCliente1">
            </app-lfsa-input>
          </div>-->
    </div>


    <!--    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [botonRegresar]="false"
                                     [formularioValido]="formulario.invalid"
                                     [loading]="loading" [textBoton]="textBoton">
        </app-lfsa-botones-formulario>-->

    <div *ngIf="!loading" class="row mt-3">
      <div class="col-md-6 offset-md-6">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" [disabled]="formulario.invalid" class="btn btn-outline-success">
              <i aria-hidden="true" class="fa fa-plus"></i>
              {{ DAT_BTNS.agregar }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 ">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!loading" [columnDefs]="columnDefs"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                         [pagination]="true" [rowData]="rowData"
                         [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.id}}">
        </ag-grid-angular>
      </div>
    </div>

  </form>

  <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                               [formularioValido]="formulario.invalid"
                               [loading]="loading" [textBoton]="textBoton">
  </app-lfsa-botones-formulario>
  <button (click)="solicitarAprobacion()" *ngIf="solicitudData.accion && solicitudData.accion === 'editar'"
          [disabled]="formulario.invalid || !(formulario.get('idPedido') && formulario.get('idPedido').value && formulario.get('idPedido').value !== '') && !(formulario.get('estado') && formulario.get('estado').value && formulario.get('estado').value !== '') || formulario.get('estado').value !== 'CREADO'"
          class="btn btn-info btn-block mt-3">
    <i class="far fa-save"></i>
    {{ DAT_BTNS.solicitarAprobacion }}
  </button>
</ng-container>


<ng-container *ngIf="!mostrarGridLista">
  <app-linea-detalle [solicitudData]="solicitudData"></app-linea-detalle>
</ng-container>
